export default __webpack_public_path__ + "cfdd6cafabc891672494e00bc34796f9.png";